import { http } from '../core/services/http'
import { IBlogPost, IAuthorProfile } from '../core/interfaces'
import { SimpleSearchPaginationParams, Pagination } from '../core/services/utils'
import { UUID } from 'node:crypto'

export const getAllBlogPosts = (params?: SimpleSearchPaginationParams) => {
    return http.get<Pagination<IBlogPost>>('/api/dashboard/blog-posts', { params })
}

export const getBlogPost = (id: UUID) => {
    return http.get<IBlogPost>(`/api/dashboard/blog-posts/${id}`)
}

export const createBlogPost = (data: IBlogPost) => {
    return http.post<IBlogPost>('/api/dashboard/blog-posts', data)
}

export const updateBlogPost = (id: UUID, data: IBlogPost) => {
    return http.put<IBlogPost>(`/api/dashboard/blog-posts/${id}`, data)
}

export const deleteBlogPost = (id: UUID) => {
    return http.delete(`/api/dashboard/blog-posts/${id}`)
}

export const toggleBlogPostPublished = (id: UUID) => {
    return http.post<IBlogPost>(`/api/dashboard/blog-posts/${id}/toggle-published`)
}

export const getBlogAuthors = () => {
    return http.get<IAuthorProfile[]>('/api/dashboard/blog-posts/authors')
}
